import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from '@env/environment';
import { BehaviorSubject } from 'rxjs';

export type InternalStateType = {
  [key: string]: any
};

@Injectable({
  providedIn: 'root'
})
export class AppState {
 private ngt18Url: string = environment.API_URL+'main/';
 private authUrl: string = environment.INVOICE_URL+'main/';
 private redisNgt18Url: string = environment.API_URL+'redis/';

  private cart = new BehaviorSubject <any> (null);
  cartUpdate = this.cart.asObservable();
  // filterPipe = new jsonParsePipe();
  constructor(private httpClient: HttpClient) {
  }

  setLocalStorageFunctions() {
    Storage.prototype.getEncryptedItem = function (item) {
      if (item) {
        let encodedKey = btoa(item);
        let itemValue = localStorage.getItem(encodedKey);
        if (itemValue) {
          return atob(itemValue);
        }
      }
      return null;
    }
    Storage.prototype.setEncryptedItem = function (item, itemValue) {
      if (item && itemValue) {
        let encodedKey = btoa(item);
        let encodedValue = btoa(itemValue);
        localStorage.setItem(encodedKey, encodedValue);
        return true;
      }
      return false;
    }
    Storage.prototype.removeEncryptedItem = function (item) {
      if (item) {
        let encodedKey = btoa(item);
        localStorage.removeItem(encodedKey);
        return true;
      }
      return false;
    }
  }

  clearLoginTime(data) {
    return this.httpClient.post(this.ngt18Url + 'core.instance.manipulateLoginTime', data);
  }
  clearRedis(data) {
    return this.httpClient.post(this.redisNgt18Url + 'api/v1/redis/clearRedis/redis', data);
  }
  getUserRights(data) {
    return this.httpClient.post(this.authUrl + 'userRights', data);
  }
  
  getMetadata() {
    return this.httpClient.get(this.authUrl + 'getMetadata');
  }

  updateCart(data) {
    this.cart.next(data);
 }
}
function toBase64(str) {
  // Encode the string as a Uint8Array
  let utf8Bytes = new TextEncoder().encode(str);
  // Create a binary string from the Uint8Array
  let binaryString = Array.from(utf8Bytes, byte => String.fromCharCode(byte)).join('');
  // Encode the binary string in Base64
  return btoa(binaryString);
}

function fromBase64(base64) {
  // Decode the Base64 string
  let binaryString = atob(base64);
  // Convert binary string to a Uint8Array
  let bytes = new Uint8Array(binaryString.length);
  for (let i = 0; i < binaryString.length; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }
  // Decode the Uint8Array to a UTF-8 string
  return new TextDecoder().decode(bytes);
}